import React, { useState, useEffect } from "react";
import { FaArrowLeft, FaFileExcel } from "react-icons/fa";
import NavBar from "../components/NavMenu";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const DetailReEnrol = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const passedQuarters = location.state?.selectedQuarters || [
    "Q1 2025",
    "Q4 2024",
  ];
  const [selectedQuarters] = useState(passedQuarters);
  const [progressionData, setProgressionData] = useState([]);
  const [progressionPrevData, setProgressionPrevData] = useState([]);

  const parseQuarterYear = (quarterStr) => {
    const [qtr, year] = quarterStr.split(" ");
    return {
      qtr: parseInt(qtr.replace("Q", "")),
      year: parseInt(year),
    };
  };

  useEffect(() => {
    const fetchData = async () => {
      const { qtr, year } = parseQuarterYear(selectedQuarters[0]);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API}/getProgressionRate?qtr=${qtr}&year=${year}`
        );

        const current = res.data.current.summary || [];
        const previous = res.data.previous.summary || [];
        setProgressionData(current);
        setProgressionPrevData(previous);
      } catch (err) {
        console.error("Failed to fetch progression rate data", err);
      }
    };
    fetchData();
  }, [selectedQuarters]);

  const handlePrevious = () => {
    const passedQuarters = location.state?.selectedQuarters || [
      "Q1 2025",
      "Q4 2024",
    ];
    const extractedQuarter = parseInt(
      passedQuarters[0].split(" ")[0].replace("Q", "")
    );
    const extractedYear = parseInt(passedQuarters[0].split(" ")[1]);

    navigate("/home", {
      state: {
        view: "new",
        selectedQuarter: extractedQuarter,
        selectedYear: extractedYear,
      },
    });
  };

  // Calculate totals
  const totals = progressionData.reduce(
    (acc, item) => {
      acc.eligible += item.eligible_count;
      acc.withdrawal += item.withdrawal_count;
      acc.rejected += item.rejected_count;
      acc.dismissed += item.dismissed_count;
      acc.failed += item.failed_count;
      acc.transfer += item.transfer_course_count;
      acc.current += item.current_status_count;
      acc.deferred += item.deferred_count;
      acc.enrolled += item.enrolled_count;
      return acc;
    },
    {
      eligible: 0,
      withdrawal: 0,
      rejected: 0,
      dismissed: 0,
      failed: 0,
      transfer: 0,
      current: 0,
      deferred: 0,
      enrolled: 0,
    }
  );

  const totalsPrev = progressionPrevData.reduce(
    (acc, item) => {
      acc.eligible += item.eligible_count;
      acc.withdrawal += item.withdrawal_count;
      acc.rejected += item.rejected_count;
      acc.dismissed += item.dismissed_count;
      acc.failed += item.failed_count;
      acc.transfer += item.transfer_course_count;
      acc.current += item.current_status_count;
      acc.deferred += item.deferred_count;
      acc.enrolled += item.enrolled_count;
      return acc;
    },
    {
      eligible: 0,
      withdrawal: 0,
      rejected: 0,
      dismissed: 0,
      failed: 0,
      transfer: 0,
      current: 0,
      deferred: 0,
      enrolled: 0,
    }
  );

  const averageProgressionRate =
    totals.eligible > 0
      ? ((totals.enrolled / totals.eligible) * 100).toFixed(2)
      : "0.00";

  const averageProgressionRatePrev =
    totalsPrev.eligible > 0
      ? ((totalsPrev.enrolled / totalsPrev.eligible) * 100).toFixed(2)
      : "0.00";

  const varianceAverageProgression = (
    parseFloat(averageProgressionRate) - parseFloat(averageProgressionRatePrev)
  ).toFixed(2);

  return (
    <>
      <NavBar />
      <div
        style={{
          backgroundColor: "#373636",
          margin: 20,
          borderRadius: 10,
          padding: 30,
          minHeight: "calc(100vh - 80px)",
          color: "#fff",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 20,
            flexWrap: "wrap",
            gap: 12,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <FaArrowLeft size={18} onClick={handlePrevious} />
            <h4 style={{ margin: 0 }}>Progression / Re-Enrollment Details</h4>
            <span style={pillStyle}>{selectedQuarters[0]}</span>
            <span style={pillStyle}>
              Total Records: {progressionData.length}
            </span>
          </div>
          <button
            onClick={() => console.log("Export to Excel")}
            className="excel-button"
          >
            <FaFileExcel size={18} /> Export to Excel
          </button>
        </div>

        <div style={{ overflowX: "auto", borderRadius: 6 }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              backgroundColor: "#1f1f1f",
              borderRadius: 6,
              overflow: "hidden",
            }}
          >
            <thead style={{ backgroundColor: "#000" }}>
              <tr>
                <th style={thStyle}>NO</th>
                <th style={thStyle}>Current Course</th>
                <th style={thStyle}>Next Course</th>
                <th style={thStyle}>Failed</th>
                <th style={thStyle}>Withdrawn</th>
                <th style={thStyle}>Eligible</th>
                <th style={thStyle}>Enrolled</th>
                <th style={thStyle}>Progression Rate (%)</th>
                <th style={thStyle}>
                  {selectedQuarters[1]} Progression Rate (%)
                </th>
                <th style={thStyle}>Variance (%)</th>
              </tr>
            </thead>
            <tbody>
              {progressionData.map((item, idx) => {
                const progressionRate =
                  item.eligible_count > 0
                    ? (
                        (item.enrolled_count / item.eligible_count) *
                        100
                      ).toFixed(2)
                    : "0.00";

                const prevItem = progressionPrevData.find(
                  (p) =>
                    p.current_course === item.current_course &&
                    p.next_course === item.next_course
                );

                const prevProgressionRate =
                  prevItem && prevItem.eligible_count > 0
                    ? (
                        (prevItem.enrolled_count / prevItem.eligible_count) *
                        100
                      ).toFixed(2)
                    : "0.00";

                const variance = (
                  parseFloat(progressionRate) - parseFloat(prevProgressionRate)
                ).toFixed(2);
                return (
                  <tr
                    key={idx}
                    style={{
                      borderTop: "1px solid #444",
                      backgroundColor: idx % 2 === 0 ? "#2b2b2b" : "#252525",
                    }}
                  >
                    <td style={tdStyle}>{idx + 1}</td>
                    <td style={tdStyle}>{item.current_course}</td>
                    <td style={tdStyle}>{item.next_course}</td>
                    <td style={{ ...tdStyle, background: "#a93226" }}>
                      {item.failed_count}
                    </td>
                    <td style={{ ...tdStyle, background: "#f39c12" }}>
                      {item.withdrawal_count}
                    </td>
                    <td style={{ ...tdStyle, background: "#2980b9" }}>
                      {item.eligible_count}
                    </td>

                    <td style={{ ...tdStyle, background: "#229954" }}>
                      {item.enrolled_count}
                    </td>
                    <td style={{ ...tdStyle, color: "#ffa726" }}>
                      {progressionRate}%
                    </td>
                    <td style={{ ...tdStyle, color: "#f5b041" }}>
                      {prevProgressionRate}%
                    </td>
                    <td
                      style={{
                        ...tdStyle,
                        color:
                          parseFloat(variance) > 0
                            ? "#2ecc71" // green if positive
                            : parseFloat(variance) < 0
                            ? "#e74c3c" // red if negative
                            : "#bbb", // grey if zero
                        fontWeight: "bold",
                      }}
                    >
                      {variance}%
                    </td>
                  </tr>
                );
              })}

              {/* Total row */}
              <tr
                style={{ backgroundColor: "#111", borderTop: "2px solid #555" }}
              >
                <td style={{ ...tdStyle, fontWeight: "bold" }} colSpan={3}></td>
                <td
                  style={{ ...tdStyle, fontWeight: "bold", color: "#ffa726" }}
                >
                  {totals.failed}
                </td>
                <td
                  style={{ ...tdStyle, fontWeight: "bold", color: "#ffa726" }}
                >
                  {totals.withdrawal}
                </td>
                <td
                  style={{ ...tdStyle, fontWeight: "bold", color: "#ffa726" }}
                >
                  {totals.eligible}
                </td>
                <td
                  style={{ ...tdStyle, fontWeight: "bold", color: "#ffa726" }}
                >
                  {totals.enrolled}
                </td>
                <td
                  style={{ ...tdStyle, fontWeight: "bold", color: "#ffa726" }}
                >
                  {averageProgressionRate}%
                </td>
                <td
                  style={{ ...tdStyle, fontWeight: "bold", color: "#f5b041" }}
                >
                  {averageProgressionRatePrev}%
                </td>
                <td
                  style={{
                    ...tdStyle,
                    fontWeight: "bold",
                    color:
                      parseFloat(varianceAverageProgression) > 0
                        ? "#2ecc71"
                        : parseFloat(varianceAverageProgression) < 0
                        ? "#e74c3c"
                        : "#bbb",
                  }}
                >
                  {varianceAverageProgression}%
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

const thStyle = {
  padding: "12px 8px",
  fontWeight: "bold",
  fontSize: 14,
  color: "#fff",
  borderBottom: "1px solid #444",
  textAlign: "center",
};

const tdStyle = {
  padding: "10px 8px",
  color: "#ddd",
  fontSize: 13,
  textAlign: "center",
};

const pillStyle = {
  background: "#444",
  padding: "6px 12px",
  borderRadius: 8,
  fontSize: 13,
  fontWeight: 500,
};

export default DetailReEnrol;
